module.exports = __webpack_public_path__ + "img/gear-solid.931733e1.svg";